import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { SignInComponent } from './layout/components/sign-in/sign-in.component';
import { SignInCheckComponent } from './layout/components/sign-in-check/sign-in-check.component';
import { SignOutComponent } from './layout/components/sign-out/sign-out.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/sign-check' },
  {
    path: 'sign-check',
    component: SignInCheckComponent,
  },
  {
    path: 'sign-in',
    component: SignInComponent,
  },
  {
    path: 'sign-out',
    component: SignOutComponent,
  },
  {
    path: 'key-cabinet',
    loadChildren: () =>
      import('./key-cabinet/key-cabinet.module').then(
        (m) => m.KeyCabinetModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'key-borrower',
    loadChildren: () =>
      import('./key-borrower/key-borrower.module').then(
        (m) => m.KeyBorrowerModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'static-pages',
    loadChildren: () =>
      import('./static-pages/static-pages.module').then(
        (m) => m.StaticPagesModule
      ),
  },
  {
    path: 'setting',
    loadChildren: () =>
      import('./settings/settings.module').then((m) => m.SettingsModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'manage-keys',
    loadChildren: () =>
      import('./manage-keys/manage-key.module').then((m) => m.KeyModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'calendar',
    loadChildren: () =>
      import('./calendar/calendar.module').then((m) => m.CalendarModule),
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
